import * as React from "react";

// style, design
import { ToolTipCell, DateCell } from "../../Displays";

import SimpleTextFilter from "src/components/Lists/Base/CompleteList/Filters/TextFilter";

import CategoryFilter from "./Filters/CategoryFilter";
import SimpleDateFilter from "src/components/Lists/Base/CompleteList/Filters/DateFilter";

export default () => [
  {
    Header: "Titel",
    accessor: "title",
    Cell: ({ value }) => <ToolTipCell text={value} />,
    Filter: SimpleTextFilter,
    filter: "text",
  },
  {
    Header: "Kategori",
    accessor: "category",
    Cell: ({ row }) => <ToolTipCell text={row.original.category_display} />,
    Filter: CategoryFilter,
    filter: "text",
  },
  {
    Header: "Uppdaterades senast",
    accessor: "inhouse_time",
    Cell: ({ value }) => <DateCell date={value} />,
    Filter: SimpleDateFilter,
    filter: "betweenDates",
  },
];

//Exporting columDefs as funciton to play nicely with detailPerms logic (components/Details/Account/UserGroups/WhiteListTable.js)

export const editableDocsColumnDefs = () => {
  return [
    {
      Header: "Titel",
      accessor: "title",
      Cell: ({ value }) => <ToolTipCell text={value} />,
      Filter: SimpleTextFilter,
      filter: "text",
    },
    {
      Header: "Kategori",
      accessor: "category",
      Cell: ({ row }) => <ToolTipCell text={row.original.category_display} />,
      Filter: CategoryFilter,
      filter: "text",
    },
    {
      Header: "Uppdaterades senast",
      accessor: "inhouse_time",
      Cell: ({ value }) => <DateCell date={value} />,
      Filter: SimpleDateFilter,
      filter: "betweenDates",
    },
  ];
};
